/* nebe-promo-fly.js: plovoucí kartička akce vlevo dole (snippet nebe-promo-fly).
 *
 * Kartička připomíná akci tomu, kdo odscrolloval lištu z obrazovky. Proto se vysouvá jen
 * tehdy, když lišta NENÍ vidět, a jen na desktopu od 990 px (mobil má na kartičku málo místa).
 *
 * Přednost mají všechny cizí vrstvy, které po zákazníkovi něco chtějí:
 *   cookie lišta Pandectes  kartička čeká, dokud zákazník nerozhodne (cookie se statusem)
 *                           a dokud je lišta .cc-window vidět
 *   popup Klaviyo           když je otevřený, kartička se nevysune a vysunutá zajede
 * Obojí se hlídá jedním 1s intervalem, který běží JEN v čase, kdy by kartička chtěla ven
 * (desktop, lišta mimo obraz). Jinak nestojí nic. MutationObserver na celé body jsme
 * nechtěli: odpočet v liště přepisuje slot až třicetkrát za vteřinu a observer by se
 * budil s ním.
 *
 * Idempotentní: druhé načtení souboru jen znovu zavolá boot a ten si všimne, že nemá co dělat.
 */
(function () {
  "use strict";

  if (window.NEBE_FLY) { window.NEBE_FLY.boot(); return; }

  var DESKTOP = "(min-width: 990px)";
  var CONSENT_GRACE_MS = 8000;
  var TICK_MS = 1000;
  var MAX_TIMEOUT = 2147483647;
  var current = null;

  // Krátký otisk textu pro klíč zavření. Nová akce s jiným textem dostane nový klíč,
  // takže se ukáže i tomu, kdo zavřel tu minulou.
  function hash(s) {
    var h = 5381;
    for (var i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0;
    return (h >>> 0).toString(36);
  }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); return true; } catch (e) { return false; } }

  function sinceLoad() {
    try { if (window.performance && performance.now) return performance.now(); } catch (e) {}
    return CONSENT_GRACE_MS;
  }

  // Prvek je opravdu vidět: ne schovaný předkem, ne display/visibility/opacity.
  function shown(el) {
    if (!el || !el.getClientRects().length) return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== "none" && cs.visibility !== "hidden" && parseFloat(cs.opacity) > 0;
  }
  function anyShown(selector, skipClass) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) {
      if (skipClass && els[i].classList.contains(skipClass)) continue;
      if (shown(els[i])) return true;
    }
    return false;
  }
  function cookieBannerShown() { return anyShown(".cc-window", "cc-invisible"); }
  // Klaviyo vkládá popup jako modální dialog přes celou obrazovku s třídou needsclick.
  function klaviyoShown() { return anyShown('[role="dialog"][aria-modal="true"].needsclick'); }

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split("; ") : [];
    for (var i = 0; i < parts.length; i++) {
      var eq = parts[i].indexOf("=");
      if (parts[i].slice(0, eq) === name) return parts[i].slice(eq + 1);
    }
    return null;
  }

  // Souhlas podle Pandectes: base64 JSON, před rozhodnutím "status":"". Když cookie
  // není (nebo se nedá přečíst) ani po 8 s a lišta nikde nesvítí, Pandectes na stránce
  // nejspíš vůbec neběží a čekat by znamenalo kartičku nikdy neukázat.
  function consentGiven() {
    var raw = readCookie("_pandectes_gdpr");
    if (raw != null) {
      try {
        var data = JSON.parse(window.atob(decodeURIComponent(raw)));
        if (data && typeof data === "object" && "status" in data) return !!data.status;
      } catch (e) {}
    }
    return sinceLoad() >= CONSENT_GRACE_MS && !cookieBannerShown();
  }

  function Fly(root) {
    var bar = document.querySelector("[data-ship-bar]");
    var mq = window.matchMedia ? window.matchMedia(DESKTOP) : null;
    var key = "nebe-fly-closed:" + hash(root.getAttribute("data-key") || "");
    var endMs = (parseInt(root.getAttribute("data-end"), 10) || 0) * 1000;
    var closedHere = false;
    var consentOk = false;
    var barOut = false;
    var on = false;
    var dead = false;
    var io = null, tick = null, endTimer = null, styleTimer = null, styleTries = 0;

    var api = { root: root, section: root.getAttribute("data-section"), destroy: destroy };

    function expired() { return endMs > 0 && Date.now() >= endMs; }
    function closed() { return closedHere || lsGet(key) === "1"; }
    function barAlive() { return !!bar && bar.isConnected && !bar.hidden; }

    // Bez lišty, bez IntersectionObserveru, po zavření nebo po konci akce kartička nemá
    // co dělat, a tak rovnou zmizí i z DOM.
    if (!bar || !mq || !("IntersectionObserver" in window) || closed() || expired()) {
      root.remove();
      return null;
    }

    // Ven ze sekce na konec body: předek s transformací nebo vlastním z-indexem
    // (hlavička je sticky) by jinak rozbil position: fixed i pořadí vrstev.
    document.body.appendChild(root);

    function setOn(v) {
      if (v === on) return;
      on = v;
      if (v) {
        waveScale();
        root.removeAttribute("inert");
        root.removeAttribute("aria-hidden");
      } else {
        root.setAttribute("inert", "");
        root.setAttribute("aria-hidden", "true");
      }
      root.classList.toggle("nebe-fly--on", v);
    }

    // Vlny mají mít rozpětí 18 px na každou stranu, ne stejné procento: kartička je
    // široká a nízká, takže stejné měřítko by do stran utíkalo víc než nahoru.
    function waveScale() {
      var card = root.querySelector(".nebe-fly-card");
      var w = card && card.offsetWidth, h = card && card.offsetHeight;
      if (!w || !h) return;
      root.style.setProperty("--nebe-fly-sx", ((w + 36) / w).toFixed(4));
      root.style.setProperty("--nebe-fly-sy", ((h + 36) / h).toFixed(4));
    }

    function gatesOpen() {
      if (!consentOk) consentOk = consentGiven();
      if (!consentOk) return false;
      return !cookieBannerShown() && !klaviyoShown();
    }

    // Od 10. 10. 2026 (David) je kartička vidět hned od načtení, ne až po odjetí lišty.
    // Pozorovatel lišty zůstává jen jako spouštěč přepočtu; podmínky cookies a Klaviyo platí dál.
    function wanted() { return mq.matches && barAlive() && !closed() && !expired(); }

    function startTick() {
      if (!tick) tick = window.setInterval(sync, TICK_MS);
    }
    function stopTick() {
      if (tick) { window.clearInterval(tick); tick = null; }
    }

    // CSS má na <link> media pro desktop. Po rozšíření okna z mobilu se teprve stahuje,
    // a bez něj by sundání hidden ukázalo holé značky přes stránku.
    function styled() { return window.getComputedStyle(root).position === "fixed"; }

    function sync() {
      if (dead) return;
      if (expired()) { destroy(true); return; }
      if (!mq.matches) {
        setOn(false);
        root.hidden = true;
        stopTick();
        return;
      }
      if (!styled()) {
        if (!styleTimer && styleTries < 40) {
          styleTries++;
          styleTimer = window.setTimeout(function () { styleTimer = null; sync(); }, 250);
        }
        return;
      }
      root.hidden = false;
      if (!wanted()) {
        setOn(false);
        stopTick();
        return;
      }
      setOn(gatesOpen());
      // Interval běží, dokud kartička chce ven: dočká se souhlasu s cookies a všimne si
      // popupu Klaviyo, který přijde až po vysunutí.
      startTick();
    }

    function onClose(e) {
      e.preventDefault();
      e.stopPropagation();
      closedHere = true;
      lsSet(key, "1");
      setOn(false);
      // Element necháme dojet animací, pak pryč, ať nezůstane v DOM ani v pořadí Tab.
      window.setTimeout(function () { destroy(true); }, 400);
      teardown();
    }

    function onMq() { sync(); }

    function armEnd() {
      if (!endMs) return;
      endTimer = window.setTimeout(function () {
        endTimer = null;
        if (expired()) destroy(true); else armEnd();
      }, Math.min(Math.max(endMs - Date.now(), 0) + 50, MAX_TIMEOUT));
    }

    function teardown() {
      stopTick();
      if (io) { io.disconnect(); io = null; }
      if (mq.removeEventListener) mq.removeEventListener("change", onMq);
      else if (mq.removeListener) mq.removeListener(onMq);
      if (endTimer) { window.clearTimeout(endTimer); endTimer = null; }
      if (styleTimer) { window.clearTimeout(styleTimer); styleTimer = null; }
    }

    function destroy(remove) {
      if (dead && !remove) return;
      dead = true;
      teardown();
      if (remove !== false && root.parentNode) root.remove();
      if (current === api) current = null;
    }

    var close = root.querySelector("[data-nebe-fly-close]");
    if (close) close.addEventListener("click", onClose);

    // Na detailu produktu odkaz nikam neodvádí: posune k výběru barvy a velikosti. Když cíl
    // na stránce chybí, platí obyčejný odkaz (href), takže klik nikdy nevyjde naprázdno.
    var link = root.querySelector(".nebe-fly-link");
    var scrollSel = root.getAttribute("data-scroll");
    if (link && scrollSel) {
      link.addEventListener("click", function (e) {
        var target = document.querySelector(scrollSel);
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 140;
        var still = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: Math.max(0, y), behavior: still ? "auto" : "smooth" });
      });
    }

    io = new IntersectionObserver(function (entries) {
      barOut = !entries[entries.length - 1].isIntersecting;
      sync();
    }, { threshold: 0 });
    io.observe(bar);

    if (mq.addEventListener) mq.addEventListener("change", onMq);
    else if (mq.addListener) mq.addListener(onMq);

    armEnd();
    try {
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (on) waveScale(); });
    } catch (e) {}

    sync();
    return api;
  }

  function boot() {
    var els = document.querySelectorAll("[data-nebe-fly]");
    var fresh = null;
    for (var i = 0; i < els.length; i++) {
      if (els[i].hasAttribute("data-nebe-fly-ready")) continue;
      // Kdyby se snippet vykreslil dvakrát, platí poslední; ostatní neinicializované pryč.
      if (fresh) fresh.remove();
      fresh = els[i];
    }
    if (!fresh) return;
    fresh.setAttribute("data-nebe-fly-ready", "");
    if (current) current.destroy(true);
    current = Fly(fresh);
  }

  window.NEBE_FLY = { boot: boot };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  // Editor motivu: sekce se přerenderuje s novou kartičkou, stará visí v body.
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:unload", function (e) {
    if (current && e.detail && current.section === e.detail.sectionId) current.destroy(true);
  });
})();
